function Icon(name) {
	const { Handlebars } = window;

	const iconTemplate = Handlebars.compile(
		document.getElementById('seller-toolbar-icons-template').innerHTML,
	);

	let instanceVars = {
		name: '',
		template: iconTemplate,
		init: (name) => {
			this.name = name;
		},
		html: () => {
			let templateData = {};
			templateData[this.name] = true;
			return this.template(templateData);
		},
	};

	Object.assign(this, instanceVars);
	this.init(name);
	return this;
}

export function Button(data) {
	const { Handlebars } = window;

	const buttonTemplate = Handlebars.compile(
		document.getElementById('seller-button-template').innerHTML,
	);
	const childTemplate = Handlebars.compile(
		document.getElementById('seller-child-button-template').innerHTML,
	);

	let instanceVars = {
		name: '',
		icon: null,
		iconEnd: null,
		label: '',
		mobileLabel: '',
		callback: null,
		weight: 50,
		conditions: [],
		params: {},
		isChild: false,
		idPrefix: 'seller-button',
		template: buttonTemplate,
		childTemplate: childTemplate,
		classes: [],
		containerClass: false,
		preventDefault: true,
		init: (data) => {
			if (typeof data === 'undefined') {
				// allow extending button class by defering the intialisation
				return;
			}
			this.setTemplate(data['template']);
			this.setChildTemplate(data['childTemplate']);
			let { name, icon, label } = data;
			this.name = name;
			this.setIcon(icon);
			this.setIconEnd(data['icon_end'] ? data['icon_end'] : this.iconEnd);
			this.label = label;
			this.mobileLabel = data['mobile_label'] ? data['mobile_label'] : this.label;
			this.callback = data['callback'];
			(this.weight = data['weight'] || data['weight'] === 0 ? data['weight'] : 50),
				this.setConditions(data['conditions']);
			this.params = data['params'] ? data['params'] : {};
			this.classes = this.setClasses(data['classes']);
			this.containerClass = data['container_class'] ? data['container_class'] : false;
			this.preventDefault = data['prevent_default'] === false ? false : this.preventDefault;
			this.bindListeners();
		},
		setTemplate: (template) => {
			if (typeof template === 'undefined') {
				template = buttonTemplate;
			}
			this.template = template;
		},
		setChildTemplate: (template) => {
			if (typeof template === 'undefined') {
				template = childTemplate;
			}
			this.childTemplate = template;
		},
		setIcon: (iconName) => {
			this.icon = new Icon(iconName);
		},
		setIconEnd: (iconName) => {
			this.iconEnd = new Icon(iconName);
		},
		setConditions: (conditions) => {
			if (typeof conditions === 'undefined') {
				return;
			}
			conditions = Array.isArray(conditions) ? conditions : [conditions];
			this.conditions = conditions;
		},
		setClasses: (classes) => {
			if (typeof classes === 'undefined') {
				classes = [];
			}
			return Array.isArray(classes) ? classes : [classes];
		},
		getClasses: () => {
			let classes = $.map(this.classes, (classItem) => {
				if (typeof classItem === 'function') {
					return classItem(this.makeParams());
				} else {
					return classItem;
				}
			}).join(' ');
			return classes;
		},
		setData: (data) => {
			this.data = data;
		},
		setChild: (state) => {
			this.isChild = state;
		},
		trigger: () => {
			if (this.callback) {
				this.callback(this.makeParams());
			}
		},
		makeParams: () => {
			let params = {};
			$.each(Object.keys(this.params), (index, key) => {
				let param = this.params[key];
				if (typeof param === 'function') {
					params[key] = param(this.data);
				} else {
					params[key] = param;
				}
			});
			return params;
		},
		getDomId: () => this.idPrefix + '-' + this.name,
		getElement: () => $('#' + this.getDomId()),
		getName: () => this.name,
		getWeight: () => {
			return this.weight;
		},
		templateData: () => ({
			id: this.getDomId(),
			label: this.label,
			mobile_label: this.mobileLabel,
			icon: this.icon.html(),
			iconEnd: this.iconEnd.html(),
			classes: this.getClasses(),
		}),
		shouldRender: () =>
			this.conditions.reduce((result, condition) => {
				return result && condition(this.makeParams());
			}, true),
		html: () => 
			this.isChild
				? this.childTemplate(this.templateData())
				: this.template(this.templateData()),
		render: () => {
			if (!this.containerClass) {
				console.error('No container specified for button to render into.');
			}
			let $container = $('.' + this.containerClass);
			if (this.shouldRender()) {
				$container.html(this.html());
			} else {
				$container.empty();
			}
		},
		redraw: () => {
			this.render();
		},
		bindListeners: () => {
			$(document)
				.off('click', '#' + this.getDomId())
				.on('click', '#' + this.getDomId(), (e) => {
					if (this.preventDefault) {
						e.preventDefault();
					}
					this.trigger();
				});
		},
	};

	Object.assign(this, instanceVars);
	this.init(data);
	return this;
}
